module.exports = TextEncoder;


//////////////////
// WEBPACK FOOTER
// external "TextEncoder"
// module id = 20
// module chunks = 0